import attrIsTruthy from '../../../../Common/js/util/attributeHelper';
import isFormValid from '../membership/isFormValid';

const dl = window.dataLayer || [];
const analytics = {
  FormSessionData: {currentStep: '0', sessionId: Date.now()},
  pushToDataLayer(obj) {
    this.logEventObject(obj);
    // Send FB Pixel tracking data
    var counter = 0;
    (function wait() {
      // escape loop after 3 tries
      if (counter > 2) {
        return;
      }
      counter++;
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', obj.event, obj);
        if (obj.category !== 'undefined' && obj.service !== 'undefined') {
          fbq('trackCustom', obj.event + "_" + obj.category + "_" + obj.service, obj);
        }
      } else {
        setTimeout(wait, 10);
      }
    })();

    dl.push(obj);
  },
  logEventObject(obj) {
    if (!window.isNonProd) return;

    console.log('----------------------------- \n' +
    'DataLayer Event Triggered: \n');
    console.log(obj);
    console.log('----------------------------- \n');
  },
  queryToObjFormat(queryStr, isObjFormat) {
    const resultArr = [];
    const queryArr = queryStr.split(';');
    const queryArrLength = queryArr.length;
    for (let i = 0; i < queryArrLength; i++) {
      const pipeArr = queryArr[i].split('&');
      const resultObj = {};
      for (let j = 0, len = pipeArr.length; j < len; j++) {
        const propValArr = pipeArr[j].split('=');
        if (propValArr != null && propValArr[0] != null && propValArr[1] != null) {
          resultObj[propValArr[0].toString()] = propValArr[1].toString() || '';
        }
      }
      resultArr.push(resultObj);
    }
    return (queryArrLength === 1 && isObjFormat) ? resultArr[0] : resultArr;
  },
  trackDataLayerPageEvent: function trackDataLayerPageEvent() {
    const $bodyEl = $('body');
    let dataItems = {};
    const pageInfoObj = analytics.queryToObjFormat($bodyEl.data('ga-page-config'), true) || {};
    var paths = window.location.pathname.split('/');
    var category = pageInfoObj.category || paths[1] || "";
    var service = pageInfoObj.service ||paths[2] || "";
    dataItems = { event: pageInfoObj.eventName, category: category, service: service };
    delete pageInfoObj.eventName;
    if (!pageInfoObj.pageCategory) {
      pageInfoObj.pageCategory = $bodyEl.data('ga-page-name') || '';
    }
    if (!pageInfoObj.pageSubCategory) {
      let pageSubCategory = $bodyEl.data('ga-page-subcategory');
      if (!pageSubCategory || pageSubCategory.length < 1 || pageSubCategory === " ") {
        const wildcardPageCategory = $('#trackingPageCategory');
        if (wildcardPageCategory) {
          pageSubCategory = wildcardPageCategory.val();
        }
      }
      pageInfoObj.pageSubCategory = pageSubCategory || '';
    }
    dataItems.page = pageInfoObj;
    this.pushToDataLayer(dataItems);
  },
  async trackDataLayerBtnEvent($triggerBtnEl) {
    const $bodyEl = $('body');
    // Here for every next and button click in guided search, this triggers.
    const searchForm = $triggerBtnEl.closest('.search-listing--tracking');
      if (searchForm) {
        const searchFilterString = searchForm.find('#filterSelections');
        const searchFilterArray = new URLSearchParams(searchFilterString.val());
        let searchFilterFormatted = "";

        for (let p of searchFilterArray.values()) {
          searchFilterFormatted += p + ",";
        }

        if (searchFilterString) {
          const gaConfig = $triggerBtnEl.data('ga-config');
          // Take the input value and convert it to an array.
          // build a new array that is just values and comma delimited.
          $triggerBtnEl.data('ga-config', gaConfig + '&searchFilter=' + searchFilterFormatted);
        }          
      }          
    // for each individual button click event within the purchase form we fire this event and populate the Data Layer with the latest information based on user interactions
    const configObj = analytics.queryToObjFormat($triggerBtnEl.data('ga-config'), true);
    var paths = window.location.pathname.split('/');
    var category = configObj.category || paths[1] || "";
    var service = configObj.service || paths[2] || "";
    const dataItems = { event: configObj.eventName, category: category, service: service };
    delete configObj.eventName;
    switch (dataItems.event) {
      case 'trackValidForm':
        if ($triggerBtnEl.closest('form').valid()) {
          if (!configObj.buttonGroup) {
            configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
          }
          dataItems.eventContext = configObj;
          this.pushToDataLayer(dataItems);
        }
        break;
      case 'trackButtonClick':          
        if (!configObj.buttonGroup) {
          configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
        }
        dataItems.eventContext = configObj;
        this.pushToDataLayer(dataItems);
        break;
        
      case 'trackForm': 
        const formActionInfo = $triggerBtnEl.data('ga-form-action-info') ? analytics.queryToObjFormat($triggerBtnEl.data('ga-form-action-info'), true) : '';
        formActionInfo.sessionId = this.FormSessionData.sessionId;
        formActionInfo.step = this.FormSessionData.currentStep;
        formActionInfo.formIsValid = formActionInfo.step === '0' || await isFormValid();
        formActionInfo.isBelowBreakpoint = window.innerWidth <= 768;

        if (!formActionInfo.formIsValid) {
          formActionInfo.nextStep = formActionInfo.step;
        }
        if (formActionInfo.isBelowBreakpoint && formActionInfo.nextStep <= 3 && formActionInfo.step >= 4) {
          formActionInfo.nextStep = '1';
        }
        formActionInfo.formCompleted = attrIsTruthy(formActionInfo.formCompleted);
        formActionInfo.formEventTime = Date.now();
        formActionInfo.timeSinceLastFormEvent = 0;
        if (this.FormSessionData.lastFormEventTime != undefined) {
          formActionInfo.timeSinceLastFormEvent = formActionInfo.formEventTime - this.FormSessionData.lastFormEventTime;
        }
        this.FormSessionData.lastFormEventTime = formActionInfo.formEventTime;
        this.FormSessionData.currentStep = formActionInfo.nextStep;
        if (!configObj.buttonGroup) {
          configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
        }
        dataItems.eventContext = configObj;
        dataItems.formAction = formActionInfo;
        this.pushToDataLayer(dataItems);
        break;
      default:
        break;
    }
  },
  init() {
    this.trackDataLayerPageEvent();
    $(document).find('[data-btn-ga-enabled]').on('click', (evt) => {
      const $btnEl = $(evt.currentTarget);
      if ($btnEl.length && attrIsTruthy($btnEl.data('btn-ga-enabled')) && $btnEl.data('ga-config')) {
        this.trackDataLayerBtnEvent($btnEl);
      }
    });

    window.document.addEventListener('openPopup', function (e) { 
      const $bodyEl = $('body');
      const modalElement = document.getElementById(e.detail.id);
      const configObj = analytics.queryToObjFormat(modalElement.dataset.gaConfig, true);
      var paths = window.location.pathname.split('/');
      var category = configObj.category || paths[1] || "";
      var service = configObj.service || paths[2] || "";
      const dataItems = { event: configObj.eventName, category: category, service: service };
      if (!configObj.buttonGroup) {
        configObj.buttonGroup = $bodyEl.data('ga-page-name') || '';
      }
      dataItems.eventContext = configObj;
      analytics.pushToDataLayer(dataItems);
     }, false);
  }
};

$(() => {
    const $bodyEl = $('body');
    if (attrIsTruthy($bodyEl.data('ga-normal-editor')) && attrIsTruthy($bodyEl.data('ga-page-enabled'))) {
    analytics.init();
  } 
});

export default analytics;